import React from 'react';
import { useNavigate } from 'react-router-dom';
import data from '../../../utils/tabsData.json';
import MobileWatch from '../../../assets/mobile_watch.svg';
import './JewelleryCollections.css';

interface JewelleryCollectionsProps {
  activeTab: string | null;
  activeSubTab: string | null;
}

const JewelleryCollections: React.FC<JewelleryCollectionsProps> = ({
  activeTab,
  activeSubTab,
}) => {
  const navigate = useNavigate();
  const activeTabData = data.tabs.find((tab) => tab.id === activeTab);
  const subTabData = activeTabData?.subtabs.find((subtab) => subtab.id === activeSubTab);

  if (!activeTabData || !subTabData) return null;

  const handleProductClick = (productId: string) => {
    if (productId === 'tourmaline') {
      navigate('/jewellery/collections/tourmaline');
    }
  };

  return (
    <div className="jewellery-collections-container">
      {subTabData.products && (
        <div className="product-design-boxes">
          {subTabData.products.map((product) => (
            <div
              key={product.id}
              className="product-box-container"
              onClick={() => handleProductClick(product.id)}
              style={{ cursor: 'pointer' }}
            >
              <div
                className="product-box"
                style={{
                  backgroundImage: product.image ? `url(${MobileWatch})` : 'none',
                  backgroundColor: product.image ? 'transparent' : '#42424233',
                }}
              ></div>
              <p className="product-label">{product.label.en}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default JewelleryCollections;
